export const VALUE_FORMATS = {
  // Percentages sometimes have the % symbol included depending on the renderer,
  // so they aren't strictly a number format.
  PERCENT: "percent",
  // Our percentages are provided by the API as a value between 0 - 1, but
  // we sometimes multiply this by 100 to display percentages between 0 - 100 in the application.
  // However, we don't want to multiply by 100 again for the download format.
  PERCENT_100: "percent100",
  NUMBER: "number",
  STRING: "string",
  CURRENCY: "currency",
}

export const ASSET_METRIC_IDS = [
  "marketValue",
  "percentEquity",
  "totalReturn",
  "specificReturn",
  "factorsReturn",
  "tradingReturn",
  "riskTotalContribution",
  "riskSpecificContribution",
  "riskFactorsContribution",
  "predictedBeta",
  "historicalBeta",
  "dynamicPredictedBeta",
]

export const METRICS = {
  PERFORMANCE: "performance",
  RISK: "risk",
  EXPOSURE: "exposure",
  BETA: "beta",
}

export const FACTOR_VIEWS = {
  ALL: "op_all",
}

export const METRIC_TYPES = {
  NET_CONTRIBUTION: "netContribution",
  Z_SCORE: "assetZScore",
  CURRENCY_EXPOSURE: "currencyExposure",
  CURRENCY_PERFORMANCE: "currencyPerformance",
  RISK_DECOMPOSITION: "riskDecomposition",
  STANDALONE: "standalone",
  CUMULATIVE_PERCENT: "cumulativePercent",
}
